import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { authApi } from '../../services/api';
import { useAuth } from '../../contexts/AuthContext';
import './Auth.css';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  // URL'den gelen doğrulama mesajı varsa göster
  const verifiedNotice = new URLSearchParams(location.search).get('verified');

  // Kayıt sayfasından yönlendirilmişse e-postayı hazır doldur
  const stateEmail = (location.state as any)?.registeredEmail || '';
  const [email, setEmail] = useState(stateEmail);
  const [password, setPassword] = useState('');

  // Sayfa yüklendiğinde ve tarayıcı autofill yapmaya çalıştığında e-postayı koru
  React.useEffect(() => {
    if (stateEmail) {
      setEmail(stateEmail);
      // Chrome'un 500ms sonra zorla telefonu basmasını engellemek için tekrar ez
      const t1 = setTimeout(() => setEmail(stateEmail), 200);
      const t2 = setTimeout(() => setEmail(stateEmail), 800);
      const t3 = setTimeout(() => setEmail(stateEmail), 1500);
      return () => {
        clearTimeout(t1);
        clearTimeout(t2);
        clearTimeout(t3);
      };
    }
  }, [stateEmail]);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await authApi.login({ email, password });
      if (res.success && res.token && res.user) {
        login(res.token, res.user);
        navigate('/dashboard');
      }
    } catch (err: any) {
      if (err.response?.status === 423 || err.response?.data?.isLocked) {
        setError(err.response?.data?.message || 'Hesabınız çok sayıda hatalı giriş nedeniyle 15 dakika süreyle dondurulmuştur.');
      } else if (err.response?.data?.isVerified === false) {
        setError('Lütfen önce e-posta adresinize gönderilen doğrulama linkine tıklayarak hesabınızı onaylayın.');
      } else {
        setError(err.response?.data?.message || 'E-posta veya şifre hatalı.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <div className="auth-logo-badge">🛡️</div>
          <h2 className="auth-title">Uzman Girişi</h2>
          <p className="auth-subtitle">İSG Uzmanı çalışma masanıza erişin</p>
        </div>

        {verifiedNotice && (
          <div className="auth-alert success">
            ✅ E-posta adresiniz başarıyla doğrulandı! Şimdi giriş yapabilirsiniz.
          </div>
        )}

        {error && <div className="auth-alert error">⚠️ {error}</div>}

        <form onSubmit={handleSubmit} className="auth-form" autoComplete="off">
          {/* Tarayıcının ilk alanlara saldırmasını önleyen sahte gizli inputlar */}
          <input type="text" style={{ display: 'none' }} tabIndex={-1} autoComplete="off" />
          <input type="password" style={{ display: 'none' }} tabIndex={-1} autoComplete="off" />

          <div className="form-group">
            <label>E-Posta Adresi veya Cep Telefonu</label>
            <input
              type="text"
              name="username"
              id="user_login_email"
              autoComplete="username"
              placeholder="ornek@uzmanisg.com veya 05xx xxx xx xx"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="auth-input"
            />
          </div>

          <div className="form-group">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <label style={{ margin: 0 }}>Şifre</label>
              <Link 
                to="/forgot-password" 
                style={{ fontSize: '0.8rem', color: '#2563eb', textDecoration: 'none', fontWeight: 600 }}
              >
                Şifremi Unuttum?
              </Link>
            </div>
            <div className="auth-password-wrapper">
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="auth-input"
              />
              <button
                type="button"
                className="auth-password-toggle"
                onClick={() => setShowPassword(!showPassword)}
                title={showPassword ? 'Şifreyi Gizle' : 'Şifreyi Göster'}
                aria-label="Şifreyi Göster veya Gizle"
              >
                {showPassword ? '👁️' : '🙈'}
              </button>
            </div>
          </div>

          <button type="submit" className="auth-submit-btn" disabled={loading}>
            {loading ? 'Giriş Yapılıyor...' : 'Giriş Yap 🚀'}
          </button>
        </form>

        <div className="auth-footer-nav">
          Hesabınız yok mu? <Link to="/register">14 Gün Ücretsiz Kaydolun</Link>
        </div>
        <div className="auth-footer-nav" style={{ marginTop: '10px', borderTop: '1px solid #eee', paddingTop: '10px' }}>
          📱 Mobil Saha Girişi: <Link to="/field/login" style={{ fontWeight: 600, color: '#2874a6' }}>Uzman Destek Mobil PWA</Link>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
